import React from 'react';
import { motion } from 'framer-motion';

const TermsOfService = () => {
    return (
        <div className="pt-32 pb-24 relative overflow-hidden bg-white">
            <div className="absolute inset-0 bg-grid-pattern opacity-[0.15]"></div>

            <section className="max-w-4xl mx-auto px-6 relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <p className="text-cyan-600 font-mono text-sm tracking-widest uppercase mb-4">Legal</p>
                    <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 tracking-tight">
                        Terms of Service
                    </h1>
                    <p className="text-slate-500 text-sm mb-16">Last updated: April 4, 2026</p>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    className="prose prose-slate max-w-none"
                >
                    <div className="space-y-12 text-slate-600 leading-relaxed">
                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">1. Agreement to Terms</h2>
                            <p>
                                By accessing or using the website and services provided by Aetrix Logic ("we," "our," or "us"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website or services.
                            </p>
                        </div>

                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">2. Services</h2>
                            <p>
                                Aetrix Logic provides custom software development, AI integration, cloud architecture, and related technology consulting services. The specific scope, deliverables, and terms of any engagement will be defined in a separate Statement of Work (SOW) or service agreement between you and Aetrix Logic.
                            </p>
                        </div>

                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">3. Intellectual Property</h2>
                            <p className="mb-4">
                                All content on this website — including text, graphics, logos, images, and software — is the property of Aetrix Logic or its licensors and is protected by intellectual property laws.
                            </p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>You may not reproduce, distribute, or create derivative works from our website content without prior written consent.</li>
                                <li>Ownership of deliverables created under client engagements will be governed by the applicable service agreement or SOW.</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">4. Client Responsibilities</h2>
                            <p className="mb-4">When engaging our services, you agree to:</p>
                            <ul className="list-disc pl-6 space-y-2">
                                <li>Provide accurate and complete information necessary for project execution.</li>
                                <li>Respond to requests for feedback, approvals, and information in a timely manner.</li>
                                <li>Ensure that any materials you provide do not infringe on third-party rights.</li>
                                <li>Comply with all applicable laws and regulations.</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">5. Payment Terms</h2>
                            <p>
                                Payment terms, including fees, milestones, and schedules, will be outlined in the applicable service agreement or SOW. Unless otherwise agreed, invoices are due within 15 days of issuance. Late payments may incur interest at the rate specified in the agreement.
                            </p>
                        </div>

                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">6. Confidentiality</h2>
                            <p>
                                Both parties agree to maintain the confidentiality of any proprietary or sensitive information shared during the course of an engagement. This obligation survives termination of any agreement between the parties.
                            </p>
                        </div>

                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">7. Limitation of Liability</h2>
                            <p>
                                To the maximum extent permitted by law, Aetrix Logic shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from or related to your use of our website or services. Our total liability shall not exceed the amounts paid by you under the applicable service agreement in the twelve (12) months preceding the claim.
                            </p>
                        </div>

                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">8. Warranties & Disclaimers</h2>
                            <p>
                                Our website and its content are provided "as is" without warranties of any kind, either express or implied. We do not warrant that the website will be uninterrupted, error-free, or free of harmful components. Warranties for services delivered under client engagements will be defined in the applicable service agreement.
                            </p>
                        </div>

                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">9. Termination</h2>
                            <p>
                                We reserve the right to suspend or terminate your access to our website at any time for any reason. Termination of service engagements will be governed by the terms set forth in the applicable service agreement or SOW.
                            </p>
                        </div>

                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">10. Governing Law</h2>
                            <p>
                                These Terms of Service shall be governed by and construed in accordance with the laws of India and the United Kingdom, as applicable based on the contracting entity. Any disputes arising from these terms shall be resolved through good-faith negotiation, and if necessary, through binding arbitration or the courts of competent jurisdiction.
                            </p>
                        </div>

                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">11. Changes to These Terms</h2>
                            <p>
                                We may revise these Terms of Service at any time. Changes will be effective upon posting to this page with a revised "Last updated" date. Your continued use of our website or services constitutes acceptance of the updated terms.
                            </p>
                        </div>

                        <div>
                            <h2 className="text-xl font-bold text-slate-900 mb-4">12. Contact Us</h2>
                            <p>
                                If you have any questions about these Terms of Service, please contact us at:
                            </p>
                            <p className="mt-4 font-medium text-slate-900">
                                Aetrix Logic<br />
                                Vadodara, India & United Kingdom<br />
                                Email: contact@aetrixlogic.com
                            </p>
                        </div>
                    </div>
                </motion.div>
            </section>
        </div>
    );
};

export default TermsOfService;
